var _JsonConfigurationBuilder_reload, _JsonConfigurationBuilder_configs, _JsonConfigurationBuilder_configuration;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { NotImplementedException } from '../../Exceptions';
import isString from '../../TypeHelpers/isString';
import isUndefinedOrNull from '../../TypeHelpers/isUndefinedOrNull';
import JsonConfiguration from './JsonConfiguration';
import mergeWith from 'lodash/mergeWith';
export default class JsonConfigurationBuilder {
    constructor() {
        _JsonConfigurationBuilder_reload.set(this, false);
        _JsonConfigurationBuilder_configs.set(this, []);
        _JsonConfigurationBuilder_configuration.set(this, void 0);
    }
    build(reload) {
        if (reload || __classPrivateFieldGet(this, _JsonConfigurationBuilder_reload, "f") || isUndefinedOrNull(__classPrivateFieldGet(this, _JsonConfigurationBuilder_configuration, "f"))) {
            let mergedConfig = {};
            for (const config of __classPrivateFieldGet(this, _JsonConfigurationBuilder_configs, "f")) {
                mergedConfig = mergeWith(mergedConfig, config, customizer);
            }
            __classPrivateFieldSet(this, _JsonConfigurationBuilder_configuration, new JsonConfiguration(mergedConfig), "f");
            __classPrivateFieldSet(this, _JsonConfigurationBuilder_reload, false, "f");
        }
        return __classPrivateFieldGet(this, _JsonConfigurationBuilder_configuration, "f");
    }
    append(value) {
        if (isString(value)) {
            __classPrivateFieldGet(this, _JsonConfigurationBuilder_configs, "f").push(JSON.parse(value));
        }
        else if (Array.isArray(value)) {
            throw new NotImplementedException();
        }
        else {
            __classPrivateFieldGet(this, _JsonConfigurationBuilder_configs, "f").push(value);
        }
        if (!__classPrivateFieldGet(this, _JsonConfigurationBuilder_reload, "f")) {
            __classPrivateFieldSet(this, _JsonConfigurationBuilder_reload, true, "f");
        }
        return this;
    }
}
_JsonConfigurationBuilder_reload = new WeakMap(), _JsonConfigurationBuilder_configs = new WeakMap(), _JsonConfigurationBuilder_configuration = new WeakMap();
function customizer(objValue, srcValue) {
    if (Array.isArray(objValue)) {
        return objValue.concat(srcValue);
    }
}
